export default __webpack_public_path__ + "static/media/magze_fa_red.86fc015e.svg";